var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyBoxBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#333;}.cls-3{fill:#333;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "iconography-template_cvm-exports_2020") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Headings"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "67.23 34.02 66.74 34.42 66.74 39.63 70.68 38.3 66.74 33.41 66.74 33.41 67.23 34.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "68.3 23.2 44.7 15.72 41.24 22.07 65.11 29.36 68.3 23.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.53,22.07l-3.41-6.82L11.34,23.18l3.31,6.22,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.79,39.47,14.73,31.29v6.29a4.67,4.67,0,0,1,2.51-.09,3.69,3.69,0,0,1,2.58,2.16,5.43,5.43,0,0,1-.61,5.08,18.73,18.73,0,0,1-4.48,4.85v6.51l24,8.53V39.77A1.07,1.07,0,0,1,38.79,39.47Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "17.86 30.37 39.68 37.79 61.84 30.33 39.87 23.62 17.86 30.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.44,49.06a.94.94,0,0,1-.85-.53l-3-6.27V64.63l24.25-8.3V42.24L44.74,49A.79.79,0,0,1,44.44,49.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "63.69 32.59 64.86 31.64 64.86 31.29 41.26 39.24 44.93 46.97 64.86 40.26 64.86 34.03 63.69 32.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M64.86,56.33l-24.25,8.3V65a.94.94,0,1,1-1.88,0v-.34l-24-8.53V49.58c-.35.27-.6.45-.69.51l-.58.4-.6-.44v6a1.87,1.87,0,0,0,1.25,1.77L39,66.73a2,2,0,0,0,.63.11,1.83,1.83,0,0,0,.61-.11l14.09-4.82c-.19-.3-.29-.49-.31-.52a.94.94,0,0,1,1.68-.85,5.29,5.29,0,0,0,.49.73l9.24-3.16a1.88,1.88,0,0,0,1.27-1.78V41.61l-1.88.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.73,37.58V31.29l24.06,8.18a1,1,0,0,1,.32-.43.93.93,0,0,1,.48-1.13,1,1,0,0,1,1.25.44l.42.89,23.77-8-3.19-.9L39.68,37.79,17.86,30.37l-2.63.81a1,1,0,0,1-1.18-.63c0-.05,0-.1,0-.15l-.77.4-.21-.38a1.86,1.86,0,0,0-.21.87v6.58a3.27,3.27,0,0,1,.62.43A3.79,3.79,0,0,1,14.73,37.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M39.39,39.67l-.6-.2a1.07,1.07,0,0,0-.06.3V64.62l.94.34.94-.33V42.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M39.14,39.16a.53.53,0,0,1,0-.12,1,1,0,0,0-.32.43l.6.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M38.73,64.62V65a.94.94,0,1,0,1.88,0v-.33l-.94.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M41.26,39.24l-.71.24a.94.94,0,0,1,.06.29v2.49l3,6.27a.94.94,0,0,0,.85.53.79.79,0,0,0,.3-.05l20.12-6.77v-2L44.93,47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M73,38.17l-6.28-7.79-.12.22a1.82,1.82,0,0,1,.15.69v2.12l3.94,4.89-3.94,1.33v2l5.82-2a.92.92,0,0,0,.6-.63A.93.93,0,0,0,73,38.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M64.86,29.41a1.55,1.55,0,0,1,.21,0l0-.09L41.24,22.07l-.54,1a1,1,0,0,1-.85.49,1,1,0,0,1-.82-.52l-.5-1L14.68,29.38l0,0v0h.07a2.09,2.09,0,0,1,.6.1l2.53.86,22-6.75,22,6.71,2.42-.82A2.09,2.09,0,0,1,64.86,29.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M40.55,39.48l.71-.24-.42-.89a1,1,0,0,0-1.25-.44A.93.93,0,0,0,39.11,39a.94.94,0,0,1,.56-.21A.92.92,0,0,1,40.55,39.48Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "64.86 40.26 64.86 42.19 64.86 42.24 66.74 41.61 66.74 39.63 64.86 40.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.73,29.41h-.07l.27.5L14,30.4c0,.05,0,.1,0,.15a1,1,0,0,0,1.18.63l2.63-.81-2.53-.86A2.09,2.09,0,0,0,14.73,29.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M64.76,30.06l.31-.61a1.55,1.55,0,0,0-.21,0,2.09,2.09,0,0,0-.6.1l-2.42.82,3.09.93,1.81,2.15V31.29a1.82,1.82,0,0,0-.15-.69l-.17.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M39.39,39.67l1.22,2.59V39.77a.94.94,0,0,0-.06-.29l-.88.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M39.39,39.67l.28.1.88-.29a.92.92,0,0,0-.88-.65.94.94,0,0,0-.56.21.53.53,0,0,0,0,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9,44.64c-2.22-2.88-1-5.74.88-6.19a3.26,3.26,0,0,1,3,.55V37.87a4.43,4.43,0,0,0-3.23-.34,3.64,3.64,0,0,0-2.56,2.4,5.57,5.57,0,0,0,1.15,5.28A33.36,33.36,0,0,0,12.85,50V48.79A33.29,33.29,0,0,1,9,44.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.21,44.73a5.43,5.43,0,0,0,.61-5.08,3.69,3.69,0,0,0-2.58-2.16,4.67,4.67,0,0,0-2.51.09v1a3.44,3.44,0,0,1,2.31-.2c1.76.36,3.18,2.73,1.36,5.85a17,17,0,0,1-3.67,4.12v1.2A18.73,18.73,0,0,0,19.21,44.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.46,50.49l.58-.4c.09-.06.34-.24.69-.51v-1.2c-.64.52-1.11.86-1.22.94h0c-.07-.06-.3-.25-.61-.53v1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.48,39.74a2.81,2.81,0,0,1,1.25-1.13v-1a3.79,3.79,0,0,0-1.26.72,3.27,3.27,0,0,0-.62-.43V39A3.54,3.54,0,0,1,13.48,39.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9.7,44.06a3.76,3.76,0,0,1-.87-3.5,1.81,1.81,0,0,1,1.22-1.2,3.74,3.74,0,0,1,.83-.1,2,2,0,0,1,1.8,1l.17.26V39a3.26,3.26,0,0,0-3-.55c-1.93.45-3.1,3.31-.88,6.19a33.29,33.29,0,0,0,3.9,4.15V47.51A29.76,29.76,0,0,1,9.7,44.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.4,44.26c1.82-3.12.4-5.49-1.36-5.85a3.44,3.44,0,0,0-2.31.2V39.7a2.38,2.38,0,0,1,2.12-.38,1.85,1.85,0,0,1,1.25,1.09,3.76,3.76,0,0,1-.51,3.37,14.72,14.72,0,0,1-2.86,3.35v1.25A17,17,0,0,0,18.4,44.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.52,41.55l.77-1.34a1.87,1.87,0,0,1,.44-.51V38.61a2.81,2.81,0,0,0-1.25,1.13,3.54,3.54,0,0,0-.63-.74v1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.53,48.13c-.19-.16-.42-.38-.68-.62v1.28c.31.28.54.47.61.53h0c.11-.08.58-.42,1.22-.94V47.13C14.27,47.54,13.85,47.89,13.53,48.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.63,29.76a1.8,1.8,0,0,1,.94-.32l.08,0-3.31-6.22,23.78-7.93,3.41,6.82,1.06-.33a.86.86,0,0,1,.55,0l1.1.33,3.46-6.35L68.3,23.2l-3.19,6.16.75.23a.9.9,0,0,1,.46.31l.39.48,3.77-7.31a.91.91,0,0,0,0-.79.94.94,0,0,0-.58-.54l-25.41-8a1,1,0,0,0-1.11.45L39.9,20.61l-3.47-6.93a1,1,0,0,0-1.14-.47L9.69,21.75a.94.94,0,0,0-.58.54,1,1,0,0,0,.05.79l3.9,7.34A2,2,0,0,1,13.63,29.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14,30.4a.92.92,0,0,1,.53-1,1.8,1.8,0,0,0-.94.32,2,2,0,0,0-.57.66l.21.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M14.65,29.4l-.08,0,.09,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M39.85,23.58a1,1,0,0,0,.85-.49l.54-1-1.1-.33a.86.86,0,0,0-.55,0l-1.06.33.5,1A1,1,0,0,0,39.85,23.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.86,29.59l-.75-.23,0,.09a1.75,1.75,0,0,1,1.52,1.15l.12-.22-.39-.48A.9.9,0,0,0,65.86,29.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66,29.77a1.85,1.85,0,0,0-.89-.32l-.31.61,1.66.86.17-.32A1.85,1.85,0,0,0,66,29.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.66,29.42l-.09,0a.92.92,0,0,0-.53,1l.89-.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M54.48,60.13a.94.94,0,0,0-.42,1.26s.12.22.31.52l1.86-.64a5.29,5.29,0,0,1-.49-.73A.94.94,0,0,0,54.48,60.13Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyBoxBlack);
export default __webpack_public_path__ + "static/media/empty-box-black.5501ff7ba154693bf641f30eaa067fb7.svg";
export { ForwardRef as ReactComponent };